// ── Color constants ──
export const GOLD = '#C8A961';
export const GOLD_LIGHT = '#E8D5A0';
export const GOLD_DARK = '#9A7B3A';
export const RED = '#E74C3C';
export const GREEN = '#27AE60';
export const BLUE = '#3498DB';

const BASE_COLORS = ['#94A3B8', '#64748B', '#8B5CF6', '#3B82F6', '#C8A961', '#10B981', '#EF4444', '#F59E0B', '#06B6D4', '#8B7355'];

export function getYearColors(): Record<number, string> {
  const colors: Record<number, string> = {};
  const startYear = 2020;
  const currentYear = new Date().getFullYear();
  for (let year = startYear; year <= currentYear + 5; year++) {
    colors[year] = BASE_COLORS[(year - startYear) % BASE_COLORS.length];
  }
  return colors;
}

export const YEAR_COLORS: Record<number, string> = getYearColors();

export const MONTHS = ['Jan','Feb','Mrt','Apr','Mei','Jun','Jul','Aug','Sep','Okt','Nov','Dec'];

// ── Helper functions ──

/** Full Belgian format: "27.016 €" (punt = duizendtal, geen afronding) */
export function fmtEur(n: number | undefined | null): string {
  if (n === undefined || n === null) return '---';
  return Math.round(n).toLocaleString('nl-BE').replace(/,/g, '.') + ' €';
}

/** Short format for chart Y-axis only */
export function fmtAxis(n: number | undefined | null): string {
  if (n === undefined || n === null) return '---';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000) return `${(n / 1_000).toFixed(0)}K`;
  return `${n.toFixed(0)}`;
}

/** @deprecated Use fmtEur for display, fmtAxis for chart axes */
export function fmt(n: number | undefined | null): string {
  return fmtEur(n);
}

export function fmtN(n: number | undefined | null): string {
  if (n === undefined || n === null) return '---';
  return n.toLocaleString('nl-BE');
}

export function pct(n: number | undefined | null): string {
  if (n === undefined || n === null) return '---';
  return `${n.toFixed(1)}%`;
}

export function sum(arr: number[] | undefined): number {
  return arr?.reduce((a, b) => a + b, 0) || 0;
}

export function cumul(arr: number[] | undefined): number[] {
  if (!arr) return [];
  return arr.reduce<number[]>((acc, v, i) => [...acc, (acc[i - 1] || 0) + v], []);
}
